import { useGetCandidate } from '../../common/useGetCandidate';
import { useGetProject } from '../../common/useGetProject';

import { MatchingSource } from './matching.types';
import { candidateName } from './matchingPresentation';

export const useMatchingSource = (source: MatchingSource) => {
  const candidate = useGetCandidate(source.type === 'candidate' ? source.uuid : undefined);
  const project = useGetProject(source.type === 'project' ? source.uuid : '');
  const query = source.type === 'candidate' ? candidate : project;
  const name =
    source.type === 'candidate' && candidate.data
      ? candidateName(candidate.data)
      : source.type === 'project' && project.data
      ? project.data.name
      : undefined;
  return { ...query, name: name || (query.isLoading ? 'Loading…' : `this ${source.type}`) };
};
